import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserService } from "@kortobaa-front/authentication";

export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const user = inject(UserService);
  const hasToken = localStorage.getItem("Token") || sessionStorage.getItem("Token");
  const hasProfile = localStorage.getItem("UserProfile") || sessionStorage.getItem("UserProfile");
  if ((user.currentUser || hasProfile) && hasToken) {
    return true;
  } else {
    router.navigateByUrl("/login");
    return false;
  }
};
